module.exports = __webpack_public_path__ + "img/azure.0386fb3d.png";